export function FormFieldError({ message }) {
    if (!message) {
        return null;
    }

    return (
        <span style={{ color: "red" }}>{message}</span>
    );
}
